import { render, staticRenderFns } from "./EditCommission.vue?vue&type=template&id=c1236d9c"
import script from "./EditCommission.vue?vue&type=script&lang=js"
export * from "./EditCommission.vue?vue&type=script&lang=js"
import style0 from "./EditCommission.vue?vue&type=style&index=0&id=c1236d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports